import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN;
const release = import.meta.env.VITE_SENTRY_RELEASE;
const promptuiTags = Object.fromEntries(Object.entries({
  promptui_session_id: import.meta.env.VITE_PROMPTUI_SESSION_ID,
  promptui_app_id: import.meta.env.VITE_PROMPTUI_APP_ID,
  promptui_sentry_project_id: import.meta.env.VITE_PROMPTUI_SENTRY_PROJECT_ID,
  promptui_sentry_project_slug: import.meta.env.VITE_PROMPTUI_SENTRY_PROJECT_SLUG,
}).filter(([, value]) => Boolean(value)));

if (dsn && typeof window !== 'undefined' && !window.__PROMPTUI_SENTRY_INIT__) {
  window.__PROMPTUI_SENTRY_INIT__ = true;
  Sentry.init({
    dsn,
    release: release || undefined,
    environment: import.meta.env.MODE || 'production',
    tracesSampleRate: 0,
    beforeSend(event) {
      event.tags = { ...(event.tags || {}), ...promptuiTags };
      return event;
    },
  });
  Sentry.setTags(promptuiTags);
}
